export { default } from './CredentialCard';
